import { Link, usePage } from '@inertiajs/react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// The port of app/(hack)/hacker/(protected)/credits/layout.tsx: a heading and the tab
// strip that wraps both credits tabs. Nothing server-side happened in it, so it stays a
// component both pages render rather than an Inertia layout.
const SPONSORS = [
  { name: 'Anthropic', slug: 'anthropic' },
  { name: 'ElevenLabs', slug: 'elevenlabs' },
];

export function CreditsShell({ children }: { children: ReactNode }) {
  const pathname = usePage().url.split('?')[0];

  return (
    <div className="container mx-auto max-w-4xl p-6">
      <div className="space-y-6">
        <div>
          <h1 className="font-bold font-title text-3xl text-primary">
            Sponsor Credits
          </h1>
          <p className="mt-2 text-muted-foreground">
            Accede a créditos y recursos de nuestros sponsors
          </p>
        </div>

        <div className="border-primary/20 border-b-2">
          <nav className="flex gap-2">
            {SPONSORS.map((sponsor) => {
              const href = `/hacker/credits/${sponsor.slug}`;
              const isActive = pathname === href;
              return (
                <Link
                  key={sponsor.slug}
                  href={href}
                  className={cn(
                    'border-2 border-transparent px-4 py-2 font-mono text-sm transition-all',
                    isActive
                      ? 'border-primary/20 border-t-primary/20 border-r-primary/20 border-b-primary border-l-primary/20 bg-primary/5 text-primary'
                      : 'text-muted-foreground hover:text-primary',
                  )}
                >
                  {sponsor.name}
                </Link>
              );
            })}
          </nav>
        </div>

        <div>{children}</div>
      </div>
    </div>
  );
}
